import { render, staticRenderFns } from "./SortTrucks.vue?vue&type=template&id=d376c470"
import script from "./SortTrucks.vue?vue&type=script&lang=js"
export * from "./SortTrucks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports